import { GraphqQlApi as api } from '../api/api.js'

export async function getStoreModule(Vue, model) {

  // Конкатенация модулей
  function mergeModules(modules) {
    let resultModule = {
      Pages: [],
      DataSources: [],
      JSActions: [],
      Snippets: [],
      Localization: {},
      Name: 'DefaultModuleImpl',
      ref: ''
    }

    for (let moduleName in modules) {
      let currentModule = modules[moduleName]
      if (currentModule.Pages && currentModule.Pages.length) {
        resultModule.Pages = [...resultModule.Pages, ...currentModule.Pages]
      }
      if (currentModule.Snippets && currentModule.Snippets.length) {
        resultModule.Snippets = [...resultModule.Snippets, ...currentModule.Snippets]
      }
      if (currentModule.DataSources && currentModule.DataSources.length) {
        resultModule.DataSources = [...resultModule.DataSources, ...currentModule.DataSources]
        let userDataSources = model.UserModel?.Modules?.[moduleName]?.DataSources
        // Проверка на наличие пользовательских DataSource
        if (userDataSources?.length) {
          resultModule.DataSources.push(...userDataSources)
        }
      }
      if (currentModule.JSActions && currentModule.JSActions.length) {
        resultModule.JSActions = [...resultModule.JSActions, ...currentModule.JSActions]
        let userJSActions = model.UserModel?.Modules?.[moduleName]?.JSActions
        // Проверка на наличие пользовательских JSActions
        if (userJSActions?.length) {
          resultModule.JSActions.push(...userJSActions)
        }
      }
      // Добавлен мердж локализации, т.к в её его отсутствие ми имеем пустой обьект после инициализации пакета (WebAppRuntime) внутри самого приложения, которое использует этот пакет.
      if (currentModule.Localization) {
        let userLocalization = model.UserModel?.Modules?.[moduleName]?.Localization || {}
        resultModule.Localization = { ...resultModule.Localization, ...currentModule.Localization, ...userLocalization }
      }
    }
    return resultModule
  }

  // Получение модулей по id версии
  async function getModelsByVersions(modules) {
    let refs = Object.values(modules).map(x => {
      let module = x
      return module.ref
    }).filter(f => !!f)

    let models

    if (refs.length == 0) {
      return []
    }
    try {
      models = await api.getModulesNonEditor(refs).then(response => response.data.webAppModelerQuery.moduleItemsNonEditor)
    } catch {
      models = await api.getModuleByIdandVersion(refs).then(response => response.data.webAppModelerQuery.moduleItems)
    }

    return models
  }

  function getAllowedMenuItems(items, disabledPages) {
    let filteredItems = []

    for (const item of items) {
      let newItem = undefined

      if (item.Action && item.Action.$Type == 'OpenPage') {
        let pageId = item.Action.Page
        let page = Vue.$routerCore.GetPageById(pageId)
        if (Vue.$routerCore.HaveAccessToPage(page)) {
          newItem = { ...item }
        }
      }

      if (item.Items && item.Items.length > 0) {
        let subItems = getAllowedMenuItems(item.Items, disabledPages)
        if (subItems.length > 0) {
          if (!newItem) {
            newItem = { ...item, Action: undefined, Items: subItems }
          }
        }
      }
      if (newItem) {
        let pageId = newItem?.Action?.Page
        let disabledPage = disabledPages.find(x => x == pageId)
        // Если страница не отключена, добавить в навигацию
        if (!disabledPage) {
          filteredItems.push(newItem)
        }
      }
    }
    return filteredItems

  }

  let moduleIds = []
  await getModelsByVersions(model.Modules).then(models => {
    moduleIds = models.map(x => x.id)
    for (let currentModule in model.Modules) {
      const current = model.Modules[currentModule]
      if (current.ref) {
        let foundModel
        foundModel = models.find(m => m.id === current.ref || m.moduleId === current.ref)
        let module = { ...current }
        if (foundModel?.model) {
          module = { ...module, ...JSON.parse(foundModel.model) }
        }
        model.Modules[currentModule] = module
      }
    }
  })

  model.Modules = { DefaultModuleImpl: mergeModules(model.Modules) }

  return {
    state: {
      model,
      currentPageId: null,
      currentPopPupPageId: null,
      currentPageParams: null,
      currentPageContext: {},
      moduleIds: moduleIds,
      listOfdisabledPages: []
    },

    getters: {
      appModel(state) {
        return state.model
      },

      AppNavigation(state) {
        let model = state.model
        let userModel = state.model.UserModel
        // Отключенные страницы
        let disabledPagesIds = new Array()
        let disabledPages = state.listOfdisabledPages.map(x => x.$ID)
        disabledPagesIds = disabledPagesIds.concat(disabledPages)

        let navigationItems = mergeNavigation(model.Navigation.Menu, userModel?.Navigation?.Menu || [])
        return getAllowedMenuItems(navigationItems, disabledPagesIds)
      },

      DataSources(state) {
        return state.model.Modules.DefaultModuleImpl.DataSources
      },

      getModules(state) {
        return state.model.Modules
      },

      // Получение страниц со всех модулей
      getAllPages(state) {
        let pages = []
        for (const module in state.model.Modules) {
          state.model.Modules[module]?.Pages.forEach(x => pages.push(x))
          state.model.UserModel?.Modules?.[module]?.Pages?.forEach(x => pages.push(x))
        }
        return pages
      },
      // Получение персонализированных значений приложения
      getAppSettings(state) {
        let appConfigValue = {
          Name: state.model.Settings.Name,
          CompanyName: state.model.Settings.CompanyName,
          FullContactInfo: state.model.Settings.FullContactInfo,
          ShortContactInfo: state.model.Settings.ShortContactInfo
        }
        if (!window.appConfig?.WsUrl) {
          return appConfigValue
        }
        let wsUrl = getCorrectWsUrl(window.appConfig.WsUrl)
        if (haveImage(state.model.Settings.Logo?.ID, wsUrl)) {
          appConfigValue.Logo = `${wsUrl}GetFile.ashx?folder=WMDL&file=${state.model.Settings.Logo.ID}&nodownload=1`
        }

        if (haveImage(state.model.Settings.MinLogo?.ID, wsUrl)) {
          appConfigValue.MinLogo = `${wsUrl}GetFile.ashx?folder=WMDL&file=${state.model.Settings.MinLogo.ID}&nodownload=1`
        }

        if (haveImage(state.model.Settings.Favicon?.ID, wsUrl)) {
          appConfigValue.Favicon = `${wsUrl}GetFile.ashx?folder=WMDL&file=${state.model.Settings.Favicon.ID}&nodownload=1`
        }
        return appConfigValue
      },

      getCurrentPageContext(state) {
        return state.currentPageContext[state.currentPageId] || {}
      }
    },

    mutations: {
      setDisabledPageInList(state, payload) {
        state.listOfdisabledPages.push(payload)
      },
      setCurrentPage(state, payload) {
        state.currentPageId = payload
      },
      setCurrentPageContext(state, { id, context }) {
        if (context === undefined ) {
          return
        }
        state.currentPageContext[id] = context
      },
      setCurrentPopPupPage(state, payload) {
        state.currentPopPupPageId = payload
      },

      setCurrentPageParams(state, payload) {
        state.currentPageParams = payload
      }
    }
  }
}

function getCorrectWsUrl(wsUrl) {
  if (!wsUrl.endsWith('/')) {
    wsUrl += '/'
  }
  return wsUrl
}

function haveImage(imgId, wsUrl) {
  if (imgId === '#CHANGED#') {
    return false
  }
  return imgId && wsUrl
}

// Слияние системной и пользовательской навигации
function mergeNavigation(systemNavigation, userNavigation) {
  for (let i = 0; i < systemNavigation.length; i++) {
    let foundInUser = userNavigation.find(u => u.$ID === systemNavigation[i].$ID)
    if (foundInUser) {
      if (!systemNavigation[i].Items.length) {
        for (let ui = 0; ui < foundInUser.Items.length; ui++) {
          let item = JSON.parse(JSON.stringify(foundInUser.Items[ui]))
          systemNavigation[i].Items.push(item)
        }
      }
      systemNavigation[i].Items = mergeNavigation(systemNavigation[i].Items, [...foundInUser.Items])
    }
  }

  for (let i = 0; i < userNavigation.length; i++) {
    let itemInSystem = systemNavigation.find(u => u.$ID === userNavigation[i].$ID)
    if (!itemInSystem) {
      let item = JSON.parse(JSON.stringify(userNavigation[i]))
      systemNavigation.push(item)
    }
  }
  return systemNavigation
}
